import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
} from "@mui/material";

interface LinkModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (link: string) => void;
  defaultLink?: string; // Текущая ссылка для редактирования
}

const LinkModal: React.FC<LinkModalProps> = ({
  open,
  onClose,
  onSubmit,
  defaultLink,
}) => {
  const [link, setLink] = useState(defaultLink || ""); // Устанавливаем текущую ссылку при редактировании

  const handleSubmit = () => {
    onSubmit(link);
    setLink("");
  };

  useEffect(() => {
    if (defaultLink) {
      setLink(defaultLink);
    }
  }, [defaultLink]);

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>
        {defaultLink ? "Edit Link" : "Add Link to Journal"}
      </DialogTitle>
      <DialogContent>
        <TextField
          label="Link"
          variant="outlined"
          fullWidth
          value={link}
          onChange={(e) => setLink(e.target.value)}
          placeholder="Enter journal link"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          disabled={!link.trim()}
        >
          {defaultLink ? "Save Changes" : "Add"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LinkModal;
